import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "_styleguide";
import { useSettings } from "_contexts/useSettings";
import IconSVG from "_assets/logos/icon.svg";
import { IconPhone, IconArrowLeft } from "@tabler/icons-react";
import "./Header.scss";

export default function Header(props) {
  const { settings, getProgress, flow } = useSettings();
  const navigate = useNavigate();
  const location = useLocation();
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const appScroll = document.getElementById("app-scroll");
      if (appScroll) {
        setHasScrolled(appScroll.scrollTop > 12);
      }
    };

    const appScroll = document.getElementById("app-scroll");
    if (appScroll) {
      appScroll.addEventListener("scroll", handleScroll);
      return () => appScroll.removeEventListener("scroll", handleScroll);
    }
  }, []);

  const progress = getProgress() || null;
  const primaryColor = settings?.primary_color || "#0f766e";
  const hideProgressBar = settings?.show_progress_bar === false;

  const currentRoute = location.pathname?.replace("/", "");
  const showBackButton = ["success", "contact-us", "screening", ""]?.includes(
    currentRoute
  )
    ? false
    : true;


  // Function to handle back navigation
  const handleBackNavigation = () => {
    if (!flow || flow.length === 0) {
      navigate(-1); // Fallback to browser back
      return;
    }

    // Find current step index in flow
    const currentStepIndex = flow.findIndex(
      (step) => step.name === currentRoute
    );

    if (currentStepIndex > 0) {
      // Navigate to previous step in flow
      const previousStep = flow[currentStepIndex - 1];
      navigate(`/${previousStep.name}`);
    } else if (currentStepIndex === 0) {
      // If on first step, navigate to root
      navigate("/");
    } else {
      // Fallback to browser back if current route not found in flow
      navigate(-1);
    }
  };

  return (
    <div id="paypath-header" className={hasScrolled ? "scrolled" : ""}>
      <a href={settings?.redirect_url || "/"} className={`logo-link ${showBackButton ? "back-button-visible" : ""}`}>
          <img src={settings?.logo_url || IconSVG} alt="" />
        </a>
      {showBackButton ? (
        <Button
          type="primary"
          className="back-button boxed"
          size="large"
          onClick={handleBackNavigation}
        >
          <IconArrowLeft size={24} />
        </Button>
      ) : null}

      <Button
        type="primary"
        className="back-button boxed header-call-button"
        size="large"
        href={`tel:${settings?.phone_number}`}
      >
        <IconPhone size={24} />
        <span className="phone-text">{settings?.contact_text || "Call us"}</span>
      </Button>
      {progress !== null && progress < 100 && !hideProgressBar ? (
        <div className="progress-bar">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%`, backgroundColor: primaryColor }}
          ></div>
        </div>
      ) : null}
    </div>
  );
}
